import fp from 'lodash/fp';
import { PublisherStatus } from '../../../../constants/publisher';

export const publishersSelector = (state) => state.publisherPortal.publisher.publishers ? state.publisherPortal.publisher.publishers : [];

export const activePublishersSelector = (state) => state.publisherPortal.publisher.publishers ? fp.filter(
  ({ status }) => status === PublisherStatus.active
)(state.publisherPortal.publisher.publishers) : [];



// WEBPACK FOOTER //
// ./src/state/modules/publisher-portal/publisher/selectors.js